import React, { Component } from 'react'
import FilterView from './views/FilterView'
import ErrorBoundry from './components/ErrorBoundry'
import $ from 'jquery'

const $body = $('body')

class WhatsOn extends Component {

    constructor(props) {
        super(props)

        let defaultView = 'event'
        const hash = window.location.hash.replace('#', '')

        this.$body = $('body')

        if( hash === 'event' || hash === 'day') {
            defaultView = hash
        }

        this.state = {
            view: defaultView,
            subComponentDidMount: false
        }

        if(defaultView === 'event') {
            $body.removeClass('state--whatson-day').addClass('state--whatson-event');
        }
        if(defaultView === 'day') {
            $body.removeClass('state--whatson-event').addClass('state--whatson-day');
        }

    }

    changeView(view) {
        this.setState({view: view})

        if(view === 'event') {
            $body.removeClass('state--whatson-day').addClass('state--whatson-event');
        }
        if(view === 'day') {
            $body.removeClass('state--whatson-event').addClass('state--whatson-day');
        }
    }

    render() {
        return (
            <ErrorBoundry subComponentDidMount={this.state.subComponentDidMount}>
                <div className="c-whats-on__viewType">
                    <ul>
                        <li className={this.state.view === 'event' ? 'active' : ''}>
                            <a href="#event" onClick={()=>{this.changeView('event')}}>By Event</a>
                        </li>
                        <li className={this.state.view === 'day' ? 'active' : ''}>
                            <a href="#day" onClick={()=>{this.changeView('day')}}>By Date</a>
                        </li>
                    </ul>
                </div>
                <FilterView filterComponentHasMounted={(val)=>{this.setState({subComponentDidMount: val})}} view={this.state.view} />
            </ErrorBoundry>
        );
    }
}

export default WhatsOn;



// WEBPACK FOOTER //
// ./src/whatson/WhatsOn.js